import { render, staticRenderFns } from "./SocialMediaIcons.vue?vue&type=template&id=ea64993c"
import script from "./SocialMediaIcons.vue?vue&type=script&lang=js"
export * from "./SocialMediaIcons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports